import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Categories"],

  endpoints: (builder) => ({
    getCategories: builder.query<any, void>({
      query: () => ({
        url: `${ApiEndpoints.getAllCategories}/SESSION`,
        method: "GET",
      }),
      providesTags: ["Categories"],
    }),
  }),
});

export const { useGetCategoriesQuery } = categoryApi;
